/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, February 2025
 */

import React, { PropTypes } from 'react';
import GrayPanel from '../../components/GrayPanel';
import ScaleBar from '../../components/ScaleBar';
import { PanelStyle } from '../../constants';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import v from '../../routes/eservices/validators';
import waiting from '../../routes/eservices/images/waiting-wheel-300x300.gif';
import ModalAlert from '../../routes/eservices/ModalAlert';

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const bodyStyle = {
  textAlign: 'center',
  marginTop: '100px',
  marginBottom: '100px'
}

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

class AnkietaSatysfakcji extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    colors: 'normal',
    style: {},
    questionsData: [],
    answers: [],

    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    isMounted: false,
    redirect: false,
  }

  validators = {
    text: [v.NotNull],
    yes_no: [v.NotSelected],
    single_choice: [v.NotSelected],
    scale: [v.NotSelected]
  }

  componentDidMount() {
    // TODO add loading
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
      };
    }
    if (colors === 'intenseYellowBlack') {
      style = {
        color: headerStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, style });

    const url = `${process.env.API_URL}/eservices/questionnaire_questions/`;
    fetch(url, {
      method: 'GET',
    }).then(r => r.json())
      .then(resp => {
        const answers = []
        for (const question of resp['questions']) {
          if (question.extra_text_showing_conditions) {
            this.validators[`${question.id}_extra_text`] = [];
          }
          
          const answer = {
            question_id: question.id,
            question_type: question.type,
            answer: '',
            extra_text: '',
          }
          answers.push(answer);
        }
        this.setState({
          questionsData: resp['questions'],
          answers,
          isMounted: true
        });
      });

  }

  onHide = () => this.setState({ showError: false }, () => this.state.redirect && this.changeLocation());

  onChange = (value, questionId, field='answer') => {
    this.setState((prevState) => {
      const updatedAnswers = prevState.answers.map((answer) =>
        answer.question_id === questionId ? { ...answer, [field]: value } : answer
      );

      const extraField = this.checkExtraField(questionId, value);
      this.validators[`${questionId}_extra_text`] = extraField ? [v.NotNull] : [];
      
      return { answers: updatedAnswers };
    }, () => this.validate(field, questionId, null));
  };

  renderErrorsInSpan = (errorField) => {
    return (    
      <div>
      {![undefined, null].includes(this.state.errors[errorField]) &&
        this.state.errors[errorField].length > 0
        ? this.state.errors[errorField].map((val) => (
          <span key={val} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>)
  }
  
  renderRadioButtons = (buttonsList, questionId) => {
    return (
      <div>
        {buttonsList.map((item, index) => (
          <div key={`radio${item}_${index}`} className="radio" style={{ marginBottom: '0px', marginTop: '0px' }}>
            <label
              style={item.disabled ? { color: 'gray' } : null}
            >
              <input
                type="radio"
                value={item.value}
                name={`question_${questionId}_option_${index}`}
                checked={this.state.answers.some(answer => answer.question_id === questionId && answer.answer === item.value)}
                onChange={e => this.onChange(e.target.value, questionId)}
              />
              <p>{`    ${item.label}`}<br /></p>
            </label>
          </div>
        ))}
        {this.renderErrorsInSpan(questionId)}
      </div>);
  }

  checkExtraField = (questionId, value=null) => {
    let show = false;
    const question = this.state.questionsData.find(q => q.id === questionId);
    const answer = this.state.answers.find(a => a.question_id === questionId);

    if (question && answer && question.type === 'yes_no' && question.extra_text_showing_conditions && question.extra_text_showing_conditions.length > 0) {
      const conditions = question.extra_text_showing_conditions;
      const selectedAnswer = value || answer.answer;
      show = conditions.includes(selectedAnswer);
    }

    return show
  }

  renderTextArea = (questionId) => {
    const answer = this.state.answers.find(a => a.question_id === questionId);
    const value = answer.answer;
    return (
      <div>
        <textarea
          name={`question_${questionId}_textarea`}
          style={{
            width: '100%',
            borderColor:
              ![undefined, null].includes(this.state.errors[questionId]) &&
              this.state.errors[questionId].length > 0
              ? 'red'
                : '#ccc',
            }
          }
          className="form-control"
          rows={5}
          value={value}
          onChange={e => this.onChange(e.target.value, questionId)}
          aria-labelledby={`question_text_${questionId}`}
        />
        {this.renderErrorsInSpan(questionId)}
      </div>
    )
  };

  renderExtraText = (questionId) => {
    const answer = this.state.answers.find(a => a.question_id === questionId);
    const value = answer && answer.extra_text;

    const show = this.checkExtraField(questionId);
    return (
      show &&
      <div>
        <p>Szczegóły:</p>
        <textarea
          name={`question_${questionId}_textarea`}
          style={{
            width: '100%',
            borderColor:
              ![undefined, null].includes(this.state.errors[`${questionId}_extra_text`]) &&
              this.state.errors[`${questionId}_extra_text`].length > 0
              ? 'red'
                : '#ccc',
            }
          }
          className="form-control"
          rows={5}
          value={value}
          onChange={e => this.onChange(e.target.value, questionId, 'extra_text')}
        />
        {this.renderErrorsInSpan(`${questionId}_extra_text`)}
      </div>
    )
  };

  validateField = (field, questionId) => {
    const checks = [];
    const question = this.state.questionsData.find(q => q.id === questionId);
    const answer = this.state.answers.find(a => a.question_id === questionId);
    const isExtraText = field === 'extra_text' ;
    const validatorKey = isExtraText ? `${questionId}_extra_text` : question.type;
    if (Object.keys(this.validators).indexOf(validatorKey) > -1) {
      for (const validator of this.validators[validatorKey]) {
        const check = validator(answer[field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = () => {
    const errors = {};
    for (const answer of this.state.answers) {
      const field = 'answer'
      const checks = this.validateField(field, answer.question_id);
      errors[answer.question_id] = checks;
      const extraField = this.checkExtraField(answer.question_id);
      if (extraField) {
        const checks = this.validateField('extra_text', answer.question_id);
        errors[`${answer.question_id}_extra_text`] = checks;
      }
    }
    return errors;
  };

  validate = (field = null, questionId = null, callback = null) => {
    let newState = null;
    if (field && questionId) {
      const question = this.state.questionsData.find(q => q.id === questionId);
      const isExtraText = field === 'extra_text' ;
      const validatorKey = isExtraText ? `${questionId}_extra_text` : question.type;
      const errorKey = isExtraText ? `${questionId}_extra_text` : questionId;
      if (Object.keys(this.validators).indexOf(validatorKey) > -1) {
        const checks = this.validateField(field, questionId);
        newState = {
          errors: {
            ...this.state.errors,
            [errorKey]: checks,
          },
        };
      }
    } else {
      const errors = this.validateGroup();
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  hasErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  changeLocation = () => {
    window.location.href = `/urzad/${this.props.prefix}`;
  }

  postValidation = () => {
    const hasFieldErrors = this.hasErrors();

    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    const data = JSON.stringify({answers: this.state.answers, prefix: this.props.prefix});
    fetch(`${process.env.API_URL}/eservices/questionnaire_answers/save/`,
      {
        method: 'POST',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
      ).then((response) => {
        if (response.status === 200) {
          this.setState({
            errorText: 'Dziękujemy za poświęcony czas i udzielenie odpowiedzi, które pomogą nam rozwijać portal e-usług!',
            errorTitle: 'Ankieta wysłana!',
            showError: true,
            loading: false,
            redirect: true,
          });
        } else {
          this.setState({
            errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
            errorTitle: 'Błąd zapisu danych.',
            showError: true,
            loading: false,
          });
          return;
        }
        
      });
  }

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    if (this.state.isMounted) {
      return (
        <div style={this.state.style}>
          <h3 id="page-title">
            <b>Badanie satysfakcji użytkowników</b>
          </h3>
          <p id="oswiadczenie">
            <b>Zapraszamy do wzięcia udziału w dobrowolnej ankiecie sprawdzającej poziom satysfakcji użytkowników uruchomionego portalu e-usług. Ankieta zawiera 10 pytań, których odpowiedzi pomogą nam uzyskać cenne informacje zwrotne o elementach portalu e-usług jakie należy zmienić.</b>
          </p>
          <GrayPanel title="Ankieta">
            {this.state.questionsData.map((question, idx) => (
              <div style={{ marginBottom: '30px' }} key={`question_${idx}`}>
                <p id={`question_text_${question.id}`}>{idx + 1}. {question.text}</p>
                {['scale'].includes(question.type) ? 
                  <div>
                    <ScaleBar onChange={this.onChange} questionId={question.id} />
                    {this.renderErrorsInSpan(question.id)}
                  </div>
                 : null}
                {['yes_no', 'single_choice'].includes(question.type) ? this.renderRadioButtons(question.options, question.id) : null}
                {question.extra_text ? this.renderExtraText(question.id) : null}
                {['text'].includes(question.type) ? this.renderTextArea(question.id) : null}
              </div>
            )
            )}
          </GrayPanel>
          {/* BUTTONS */}
          <div className="row mobile-row">
            <div className="col-sm-12">
              <button
                type="submit-lg"
                className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={() => this.setState({ loading: true }, () => this.startService())}
              >
                Wyślij ankietę
              </button>
              <button
                type="submit-lg"
                className="btn btn-default"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={() => this.changeLocation()}
              >
                Anuluj
              </button>
            </div>
          </div>
          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />
        </div>
      )
    }

    return (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={bodyStyle}
      >
        <img alt="Loader" src={waiting} />
      </GrayPanel>
    )
  }
}

export default AnkietaSatysfakcji;



// WEBPACK FOOTER //
// src/components/AnkietaSatysfakcji/AnkietaSatysfakcji.js